import React, { Component } from 'react';
import { LangConsumer } from 'utils/LangProvider';
import { Tooltip } from 'antd';
import { Icon, } from 'libs';
import _ from 'lodash';
import WebApp from '../../../webapp';
import {defaultPic, defaultPlate, attrTrans, transStr, getAgeRange} from './../utils';
class PreviewInfo extends Component {
    constructor (props) {
        super(props);
        this.ComponentName = 'PreviewInfo';
    }
    componentDidMount () {
    }
    // 预览信息属性
    getAttrContent = () => {
        const { $t, store: { attrMap, details }, viewMode, index, vehicleSignArr, attrType, portraitEnable, portraitVideoAnalyseRule } = this.props;
        let data = details[index].info;
        if (!(data && data.Type)) return null;
        let dType = (data.Type === 'plate' ? 'car' : data.Type);//物体类型
        let portraitMode = null;
        if (viewMode === 'portrait') {
            portraitMode = portraitVideoAnalyseRule && portraitVideoAnalyseRule.Config &&
                                portraitVideoAnalyseRule.Config.Compliant &&
                                portraitVideoAnalyseRule.Config.Compliant.CompliantType;
        }
        //睿厨 只展示不合格属性，算法只要检测到某项不合格，其他就不检查了 因此不能显示所有属性
        if (viewMode === 'smartKitchen') {
            return _.map(attrMap[attrType][dType] && attrMap[attrType][dType].attrs, (obj, key) => {
                let val = data[key];
                // val = '03';
                if (obj.enabled && obj.selected && obj.visible) {
                    let varStr = '';
                    if (key === 'HasMask' || key === 'HasChefHat') {
                        if (val !== 1) {//不合格
                            return null;
                        } else {
                            varStr = $t('ivs.FaceNo');
                        }
                    } else if (key === 'ChefClothesColor') {
                        if (val && val !== 'Unknown') {
                            varStr = $t(transStr[val]) || $t(val);
                        } else {
                            return null;
                        }
                    }
                    return (
                        <div key={key} line=''>
                            <Tooltip title={$t(attrTrans[key] || key)}>
                                <span className='icon_fail' attr_key=''>
                                    {$t(attrTrans[key] || key)}
                                </span>
                            </Tooltip>
                            <Tooltip title={varStr}>
                                <span className='icon_fail' attr_val=''>
                                    {varStr}
                                </span>
                            </Tooltip>
                        </div>
                    );
                } else {
                    return null;
                }
            });
        }
        return _.map(attrMap[attrType][dType] && attrMap[attrType][dType].attrs, (obj, key) => {
            let val = data[key];
            // val = '03';
            if (obj.enabled && obj.selected && obj.visible) {
                let varStr = '';
                if (key === 'Age') {
                    varStr = $t(getAgeRange(val)) || '--';
                } else if (key === 'AgeNum' && WebApp.GongAnDetect) {
                    val = data['Age'];
                    if (val === '' || val === undefined || val === null) {
                        varStr = '--';
                    } else {
                        varStr = val;
                    }
                } else if (key === 'Hair' && WebApp.GongAnDetect) {
                    val = data['Age'];
                    if (val === '' || val === undefined || val === null) {
                        varStr = '--';
                    } else {
                        // 作假随机显示长短发
                        let num = parseInt(Math.random() * 11,10);
                        if (num > 5) {
                            varStr = $t('ivs.ShortHair');
                        } else {
                            varStr = $t('ivs.LongHair');
                        }
                    }
                } else if (key === 'State' && WebApp.GongAnDetect) {
                    // 作假随机显示静止还是运动
                    let num = parseInt(Math.random() * 11,10);
                    if (num > 5) {
                        varStr = $t('ivs.Static');
                    } else {
                        varStr = $t('ivs.Move');
                    }
                } else if (key === 'Confidence' && WebApp.GongAnDetect) {
                    val = data['confidence'];
                    if (val === '' || val === undefined || val === null) {
                        varStr = '--';
                    } else {
                        varStr = val;
                    }
                } else if (key === 'GPS' && WebApp.GongAnDetect) { //GPS定位作假，web产生随机数
                    if (dType === 'face') {
                        val = data['Age'];
                    } else if (dType === 'body') {
                        val = data['UpClothes'];
                    } else if (dType === 'car') {
                        val = data['VehicleType'];
                    }
                    if (val === '' || val === undefined || val === null) {
                        varStr = '--';
                    } else {
                        val = '120°' + parseInt(Math.random() * 13 + 5, 10) + '\'' + parseInt(Math.random() * 60, 10) + '",' + '30°' + parseInt(Math.random() * 13 + 5, 10) + '\'' + parseInt(Math.random() * 60, 10) + '"';
                        varStr = val;
                    }
                } else if (key === 'VehicleSign') {
                    val = data.VehicleSignEx;
                    if (val === '' || val === undefined || val === null) {
                        varStr = '--';
                    } else {
                        varStr = $t(vehicleSignArr[val] || 'com.Unknow');
                    }
                } else if (key === 'AttachmentStatus') {
                    if (val === '' || val === undefined || val === null) {
                        varStr = '--';
                    } else if (val && val.length) {
                        varStr = val.filter(ele1 => ele1 !== 'Unknow').map(ele2 => $t(transStr[ele2])).join('\\') || $t('com.Unknow');
                    } else {
                        varStr = $t('ivs.FaceNo');
                    }
                } else if (key === 'HatStatus' && viewMode === 'portrait' && portraitEnable) {
                    key = 'Helmet';
                    if (val === '' || val === undefined || val === null) {
                        varStr = '--';
                    } else if (val === 'conf_ivs.face.haveHat' || val === 'ivs.Helmet' || val === 'Glasses_N') {
                        varStr = $t('ivs.FaceNo');
                    } else if (val === 'ivs.SafeHat') {
                        varStr = $t('ivs.FaceHave');
                    } else if (val === 'Unknown') {
                        varStr = $t('com.Unknow');
                    }
                } else if (key === 'PickOrNot' && WebApp.GongAnDetect) {
                    if (val === '' || val === undefined || val === null) {
                        varStr = '--';
                    } else if (val === 0) {
                        varStr = $t('com.Unknow');
                    } else if (val === 1) {
                        varStr = $t('ivs.FaceNo');
                    } else if (val === 2) {
                        varStr = $t('ivs.FaceHave');
                    }
                } else if (key === 'Helmet' || key === 'WorkClothes' || key === 'Mask' || key === 'Glove' || key === 'Apron' || key === 'Boot' || key === 'ShoesCover') {
                    if (val === '' || val === undefined || val === null) {
                        varStr = '--';
                    } else if (val === 0) {
                        varStr = $t('com.Unknow');
                    } else if (val === 1) {
                        varStr = $t('ivs.FaceNo');
                    } else if (val === 2) {
                        varStr = $t('ivs.FaceHave');
                    } else { //这里是作业检测用到的属性，防止其他人体事件（控件透传或处理过的数据不统一，除上述情况，处理过的数据再次翻译）
                        varStr = $t(transStr[val]) || $t(val) || '--';
                    }
                } else {
                    varStr = $t(transStr[val]) || $t(val) || '--';
                }
                let className = null;
                if (portraitEnable && viewMode === 'portrait' && data.AlarmCompliance === (portraitMode + 1)) {
                    if (portraitMode) {
                        if (data.CompliantDetails && data.CompliantDetails.includes(key)) {
                            className = 'icon_success';
                        }else {
                            className = '';
                        }
                    }else {
                        if (data.CompliantDetails && data.CompliantDetails.includes(key)) {
                            className = 'icon_fail';
                        }else {
                            className = '';
                        }
                    }
                }else {
                    className = '';
                }
                return (
                    <div key={key} line=''>
                        <Tooltip title={$t(attrTrans[key] || key)}>
                            <span className={className} attr_key=''>
                                {$t(attrTrans[key] || key)}
                            </span>
                        </Tooltip>
                        <Tooltip title={varStr}>
                            <span className={className} attr_val=''>
                                {varStr}
                            </span>
                        </Tooltip>
                    </div>
                );
            } else {
                return null;
            }
        });
    }
    render () {
        const { store: { listLayout, details, }, $t ,chnNum, viewMode, index, portraitEnable, portraitMode, } = this.props;
        const detail = details && details[index].info || {};
        return (
            <div detail={index} className={(viewMode === 'portrait' || viewMode === 'smartKitchen') ? 'portraitBox' : ''}>
                <div wrap=''>
                    {listLayout === 'parking' ?
                        <>
                            {/* 车位检测（6位车牌识别） */}
                            <div className={`parking-main ${detail.PrewViewUrl ? '' : 'empty-pic'}`} style={{ backgroundImage: `url('${detail.PrewViewUrl || defaultPic}')` }}></div>
                            <div className='parking-bottom'>
                                <div className='parking-bottom-list'>
                                    <div className='parking-info-name'>{$t('ivs.PlatePic')}</div>
                                    <div className={`parking-number ${detail.PlateUrl ? 'parking-number-img' : 'parking-no-img'}`} style={{ backgroundImage: `url('${detail.PlateUrl || defaultPlate}')` }}></div>
                                </div>
                                <div className='parking-bottom-list'>
                                    <div className='parking-info-name'>{$t('ivs.PlateNo')}</div>
                                    <div className='parking-number parking-number-str'>{detail.PlateNo || '--'}</div>
                                </div>
                            </div>
                        </> :
                        <>
                            {/* 其他模式（不是车位检测模式） */}
                            <div pic={detail && ((detail.Type === 'face' || detail.Type === 'classroom') && detail.Candidate ? 'face_compare' : detail.Type) || ''}>
                                {detail && (detail.Type === 'car' || detail.Type === 'plate') ? (
                                    <>
                                        <div className={detail.PrewViewUrl ? '' : 'empty-pic'} style={{ backgroundImage: `url('${detail.PrewViewUrl || defaultPic}')` }}>{chnNum > 1 && detail.PrewViewUrl && <Icon type={'triangle' + (detail.channel + 1)} />}</div>
                                        <div className={detail.PlateUrl ? '' : 'empty-pic'} style={{ backgroundImage: `url('${detail.PlateUrl || defaultPlate}')` }}></div>
                                    </>
                                ) : null}
                                {detail && detail.Type === 'face' && !detail.Candidate ? (
                                    <div className={detail.url ? '' : 'empty-pic'} style={{ backgroundImage: `url('${detail.url || defaultPic}')` }}>{chnNum > 1 && detail.url && <Icon type={'triangle' + (detail.channel + 1)} />}</div>
                                ) : null}
                                {detail && detail.Type === 'face' && detail.Candidate ? (
                                    <>
                                        <div className={detail.url ? '' : 'empty-pic'} style={{ backgroundImage: `url('${detail.url || defaultPic}')` }}>{chnNum > 1 && detail.url && <Icon type={'triangle' + (detail.channel + 1)} />}</div>
                                        <div className={detail.url ? '' : 'empty-pic'} style={{ backgroundImage: `url('${detail.Candidate[0].CandidateUrl[0] || defaultPic}')` }}>{chnNum > 1 && detail.Candidate[0].CandidateUrl[0] && <Icon type={'triangle' + (detail.channel + 1)} />}</div>
                                        <div sim_wrap=''>
                                            <div sim_bar='' style={{ width: detail.Candidate[0].Similarity + '%' }}></div>
                                            <div sim_val=''>{(detail.Candidate[0].Similarity + '%')}</div>
                                        </div>
                                    </>
                                ) : null}
                                {detail && detail.Type === 'body' ? (
                                    <div className={detail.url ? '' : 'empty-pic'} style={{ backgroundImage: `url('${detail.url || defaultPic}')` }}>{chnNum > 1 && detail.url && <Icon type={'triangle' + (detail.channel + 1)} />}</div>
                                ) : null}
                                {detail && detail.Type === 'nonmotor' ? (
                                    <div className={detail.PrewViewUrl ? '' : 'empty-pic'} style={{ backgroundImage: `url('${detail.PrewViewUrl || defaultPic}')` }}>{chnNum > 1 && detail.PrewViewUrl && <Icon type={'triangle' + (detail.channel + 1)} />}</div>
                                ) : null}
                                {viewMode === 'portrait' && portraitEnable && detail && detail.url && detail.AlarmCompliance === (portraitMode + 1) &&
                                    <img className='portraitIcon'
                                        src={portraitMode ? require('../../../assets/label_pass.png') : require('../../../assets/label_fail.png')}
                                        alt=""
                                    />
                                }
                                {viewMode === 'smartKitchen' && detail && detail.url &&
                                    <img className='portraitIcon'
                                        src={require('../../../assets/label_fail.png')}
                                        alt=""
                                    />
                                }
                                {detail && detail.Type === 'classroom' ? (
                                    <>
                                        <div className={detail.url ? '' : 'empty-pic'} style={{ backgroundImage: `url('${detail.url || defaultPic}')` }}>{chnNum > 1 && detail.url && <Icon type={'triangle' + (detail.channel + 1)} />}</div>
                                        {
                                            detail.Candidate ?
                                                <div className={detail.Candidate[0] ? '' : 'empty-pic'} style={{ backgroundImage: `url('${detail.Candidate[0].CandidateUrl[0] || defaultPic}')` }}>{chnNum > 1 && detail.Candidate[0].CandidateUrl[0] && <Icon type={'triangle' + (detail.channel + 1)} />}</div>
                                                :
                                                <div className={'empty-pic'} style={{ backgroundImage: `url('${defaultPic}')` }}></div>
                                        }
                                        {detail.Candidate && detail.Candidate[0] && <div sim_wrap=''>
                                            <div sim_bar='' style={{ width: detail.Candidate[0].Similarity + '%' }}></div>
                                            <div sim_val=''>{(detail.Candidate[0].Similarity + '%')}</div>
                                        </div>}
                                    </>
                                ) : null}
                            </div>
                            <div attr=''>
                                <div attr_cell=''>
                                    {this.getAttrContent()}
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        );
    }
}
export default LangConsumer(PreviewInfo);